<template>
  <v-menu open-on-hover bottom left offset-y max-width="768">
    <img
      slot="activator"
      class="dt-icon v4 nop"
      :src="`static/icons/${menu.icon}`"
      :alt="menu.text"
      :title="menu.text"
      :style="{
        ...(menu.style || {}),
        cursor: 'pointer',
      }"
    />
    <v-card
      :style="{
        padding: '8px',
        ...cardStyle,
        ...(menu.cardStyle || {}),
      }"
    >
      <div>
        <div v-html="menu.html"></div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    menu: {
      type: Object,
    },
  },
  computed: {
    cardStyle() {
      if (!this.menu.mode || this.menu.mode == "dark") {
        return {
          background: "black",
          color: "white",
        };
      } else if (this.menu.mode == "light") {
        return {};
      }
    },
  },
};
</script>